module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('mt-header', {
    attrs: {
      "title": "用户注册"
    }
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "registerContent"
  }, [_c('form', {
    ref: "rulesForm",
    attrs: {
      "model": _vm.rulesForm
    }
  }, [_c('section', [_c('div', [_c('label', {
    attrs: {
      "id": "username"
    }
  }, [_vm._v("用户名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesForm.username),
      expression: "rulesForm.username"
    }],
    attrs: {
      "type": "text",
      "id": "username",
      "placeholder": "请输入用户名"
    },
    domProps: {
      "value": (_vm.rulesForm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rulesForm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('div', [_c('label', {
    attrs: {
      "id": "phone"
    }
  }, [_vm._v("电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesForm.phone),
      expression: "rulesForm.phone"
    }],
    attrs: {
      "type": "text",
      "id": "phone",
      "placeholder": "请输入电话号码"
    },
    domProps: {
      "value": (_vm.rulesForm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rulesForm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesForm.verification),
      expression: "rulesForm.verification"
    }],
    attrs: {
      "type": "text",
      "id": "verification",
      "placeholder": "4位数字"
    },
    domProps: {
      "value": (_vm.rulesForm.verification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rulesForm.verification = $event.target.value
      }
    }
  }), _vm._v(" "), _c('mt-button', {
    staticClass: "codeBtn",
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("获取验证码")])], 1)]), _vm._v(" "), _c('section', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesForm.password),
      expression: "rulesForm.password"
    }],
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.rulesForm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rulesForm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rulesForm.dbpassword),
      expression: "rulesForm.dbpassword"
    }],
    attrs: {
      "type": "password",
      "id": "dbpassword",
      "placeholder": "请重复输入密码"
    },
    domProps: {
      "value": (_vm.rulesForm.dbpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rulesForm.dbpassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('mt-button', {
    staticClass: "btn",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.registerSubmit
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            点击 立即注册 即表示您同意醉品"), _c('span', [_vm._v("用户协议")]), _vm._v("和"), _c('span', [_vm._v("隐私协议")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-721f6f4f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/register.vue
// module id = 227
// module chunks = 1